<!--
 * @Desc:
 * @Author: may.li
 * @Date: 2023-05-11 14:11:36
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-12-20 16:33:46
-->
<template>
  <div class="app-container">
    <!-- 查询条件 -->
    <div class="search-div common-section-bg">
      <div class="shaixuan-item">
        <el-select
          v-model="queryParam.community_id"
          clearable
          filterable
          placeholder="请选择小区"
        >
          <el-option v-for="item in optionList"
                     :key="item.id"
                     :label="item.commName"
                     :value="item.id"/>
        </el-select>
      </div>
      <div class="shaixuan-item">
        <el-input
          v-model="queryParam.key"
          size="mini"
          clearable
          placeholder="请输入关键词查找"
        />
      </div>
      <div class="shaixuan-item">
        <el-button
          type="primary"
          style="background: #1890ff; border-color: #1890ff"
          @click="searchClick()"
          icon="el-icon-search"
        >
          查询
        </el-button>
        <el-button
          @click="clickItem(0)"
          type="primary"
          style="background: #1890ff; border-color: #1890ff"
          icon="el-icon-plus"
        >
          新增
        </el-button>
      </div>
    </div>
    <!-- 列表展示 -->
    <div class="common-section-bg common-section-body">
      <el-table
        v-loading="listLoading"
        :data="tableData"
        size="mini"
        style="width: 100%; min-height: 300px"
      >
        <el-table-column prop="id" label="id" width="80"/>
        <el-table-column label="小区" width="120">
          <template slot-scope="scope">
            {{ scope.row.community.commName || '' }}
          </template>
        </el-table-column>
        <el-table-column prop="title" label="标题" width="200"/>
        <el-table-column label="封面图" width="200">
          <template slot-scope="scope">
            <el-image
              style="width: 100px; height: 100px"
              :src="$adddom(scope.row.thumb)"
              :preview-src-list="[$adddom(scope.row.thumb)]">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column label="小程序码" width="200">
          <template slot-scope="scope">
            <el-image
              style="width: 100px; height: 100px"
              :src="$adddom(scope.row.mini_thumb)"
              :preview-src-list="[$adddom(scope.row.mini_thumb)]">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="begin_at" label="活动开始时间" width="200"/>
        <el-table-column prop="end_at" label="活动结束时间" width="200"/>
        <el-table-column prop="points" label="签到积分" width="200"/>
        <el-table-column prop="admin" label="状态">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="1"
              :inactive-value="0"
              @change="changeStatus(scope.row)"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="admin" label="排序" width="120">
          <template slot-scope="scope">
            <el-input-number
              size="mini"
              style="width: 100px"
              v-model="scope.row.sort"
              controls-position="right"
              @change="handleChange(scope.row)"
              :min="0"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          align="center"
          label="操作"
          width="340"
        >
          <template slot-scope="scope">
            <div class="btns-wrap">
              <el-button
                type="danger"
                style="
                                    background: #1067e0;
                                    border-color: #1067e0;
                                "
                @click="clickItem(1, scope.row)"
              >修改
              </el-button
              >
              <el-button
                type="danger"
                style="
                                    background: #13ce66;
                                    border-color: #13ce66;
                                "
                @click="person(scope.row)"
              >报名列表
              </el-button
              >
              <el-button
                type="danger"
                style="
                                    background: #409eff;
                                    border-color: #409eff;
                                "
                @click="comment(scope.row)"
              >活动评论
              </el-button
              >
              <el-button
                type="danger"
                @click="remove(scope.row)"
                style="
                                    background: #ff4949;
                                    border-color: #ff4949;
                                "
              >删除
              </el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <pagination
        v-show="total"
        :total="total"
        :page.sync="queryParam.page"
        :limit.sync="queryParam.size"
        @pagination="getList"
      />
    </div>
    <el-drawer
      custom-class="custom-drawer"
      :visible.sync="showDrawer"
      :close-on-press-escape="false"
      :wrapper-closable="false"
      :show-close="false"
      size="1000px"
    >
      <template slot="title">
        <div class="custom-title">
          <div class="title-name">{{ isEdit ? "编辑" : "新增" }}</div>
          <i
            class="el-icon-circle-close close-btn pointer"
            @click="closeDrawerFun"
          />
        </div>
      </template>
      <div class="custom-content">
        <commonAdd
          ref="commonAdd"
          @onUpdateDrawer="onUpdateDrawer($event)"
        />
      </div>
    </el-drawer>
  </div>
</template>

<script>
import fetch from "@/api/tianzheng/activity";
import Qu from "@/api/tianzheng/Qu";
import commonAdd from "./activityAdd.vue";
import Pagination from "@/components/Pagination"; // Secondary package based on el-pagination
export default {
  data() {
    return {
      optionList: [],
      queryParam: {
        key: "",
        community_id: "",
        page: 1,
        size: 10,
      },
      total: 0,
      listLoading: false,
      tableData: [],
      isEdit: 0, // 0新增 1编辑
      showDrawer: false,
    };
  },
  components: {
    Pagination,
    commonAdd,
  },
  created() {
  },
  mounted() {
    this.getList();
    this.getSelectCity()
  },
  methods: {
    // 跳转报名列表
    person(item) {
      this.$toPath('/activity/person?id=' + item.id, {})
    },
    // 跳转评论列表
    comment(item) {
      this.$toPath('/activity/comment?id=' + item.id, {})
    },
    // 获取下拉列表
    getSelectCity() {
      Qu.select({}).then(res => {
        if (res.code == 200) {
          this.optionList = res.result;
        }
      })
    },
    // 排序变更
    handleChange(row) {
      let params = {
        id: row.id,
        sort: row.sort,
      };
      fetch.sort(params).then((res) => {
        if (res.code == 200) {
          this.getList();
        } else {
          this.getList();
          this.$message.error(res.message);
        }
      });
    },
    /**
     * @name: 更改状态
     * @param {*} val
     * @return {*}
     * @desc:
     */
    changeStatus(val) {
      let params = {
        id: val.id,
        status: val.status,
      };
      fetch.status(params).then((res) => {
        if (res.code == 200) {
          this.getList();
        } else {
          this.getList();
          this.$message.error(res.message);
        }
      });
    },
    // 更新弹层状态
    onUpdateDrawer(status) {
      console.log("status", status);
      if (status == 1) {
        // 成功
        this.showDrawer = false;
        this.getList();
      } else if (status == -1) {
        // 失败
        this.showDrawer = false;
      }
    },
    /**
     * @name: 关闭弹层
     * @return {*}
     * @desc:
     */
    closeDrawerFun() {
      this.showDrawer = false;
      this.$refs.commonAdd.resetForm();
    },
    /**
     * @name: 点击子项 0新增 1编辑
     * @param {*} type
     * @param {*} id
     * @return {*}
     * @desc:
     */
    clickItem(type, row) {
      let that = this;
      this.showDrawer = true;
      this.isEdit = type;
      // 给组件传值
      let obj = {
        type: type,
        id: row ? row.id : "",
      };
      this.$nextTick(function () {
        that.$refs.commonAdd.initFun(obj);
      });
    },
    /* 查询按钮，页码重置，查询数据 */
    searchClick() {
      this.queryParam.page = 1;
      this.getList();
    },
    /* 查询tableData数据 */
    getList() {
      let that = this;
      this.listLoading = true;
      fetch.list(that.queryParam).then((res) => {
        that.listLoading = false;
        that.tableData = res.result.list;
        that.total = res.result.total;
      });
    },
    remove(row) {
      let that = this;
      that.$confirm("确定删除该内容吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 调用接口
          fetch.remove({id: row.id}).then((res) => {
            if (res.code == 200) {
              that.$message.success(res.message);
              that.getList();
            } else {
              that.$message.error(res.message);
            }
          });
        })
        .catch(() => {
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.app-container {
  min-height: calc(100vh - 98px);
}
</style>
